import { useEffect, useState } from "react";
import api from "@/lib/api";
import { formatDate } from "@/lib/constants";
import { MessageCircle, CheckCheck } from "lucide-react";

export default function Notifications() {
  const [items, setItems] = useState([]);
  useEffect(() => { api.get("/notifications").then((r) => setItems(r.data)).catch(() => {}); }, []);

  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl sm:text-3xl font-extrabold text-slate-900 font-heading tracking-tight">WhatsApp Automation</h1>
        <p className="text-sm text-slate-500 mt-1">Automated messages sent to customers on every status change (simulated)</p>
      </div>

      <div className="max-w-2xl space-y-3">
        {items.map((n) => (
          <div key={n.id} data-testid={`notification-${n.id}`} className="flex gap-3 p-4 rounded-xl bg-white border border-slate-200 shadow-sm">
            <div className="w-10 h-10 rounded-full bg-emerald-100 text-emerald-600 flex items-center justify-center flex-shrink-0"><MessageCircle size={18} /></div>
            <div className="flex-1 min-w-0">
              <div className="flex items-center justify-between gap-2">
                <div className="text-sm font-semibold text-slate-900">{n.customer_name} <span className="text-slate-400 font-normal">· {n.customer_phone || "no phone"}</span></div>
                <span className="text-[10px] px-2 py-0.5 rounded-full bg-slate-100 text-slate-500 whitespace-nowrap">{n.type}</span>
              </div>
              <div className="text-sm text-slate-600 mt-1 bg-emerald-50 border border-emerald-100 rounded-lg px-3 py-2">{n.message}</div>
              <div className="flex items-center gap-1 text-xs text-emerald-600 mt-1.5"><CheckCheck size={13} /> Sent · {formatDate(n.created_at)}</div>
            </div>
          </div>
        ))}
        {items.length === 0 && <div className="text-sm text-slate-400 text-center py-12">No notifications yet.</div>}
      </div>
    </div>
  );
}
